import * as React from "react";
import DeletePanel from "../../../components/CustomDelete/DeletePanel";
import strings from "../../../config/localization";
import { useDeleteExternalForceMutation } from "../../../services/appln";

export default function DeleteExternalForce(props: any): any {
  return (
    <DeletePanel
      deleteMutation={useDeleteExternalForceMutation}
      deleteArgs={{
        bandobastId: props.bandobastId,
        personnelId: props.personnelId,
      }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteExternalForceTitle}
      confirmationDialogMsg={strings.deleteExternalForceConfirmation}
      errorDialogTitle={strings.deleteExternalForceFailedTitle}
      errorDialogMsg={strings.deleteExternalForceFailedMsg}
    />
  );
}
